import React from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function About() {
  return (
    <div className="min-h-screen">
      <Header />
      <section className="max-w-3xl mx-auto text-center px-4 pt-24 pb-8">
        <div className="sv-overline mb-4">About SV Talent Agency</div>
        <h1 className="font-serif-hero text-4xl lg:text-7xl text-[#F4EFE4]">Where talent meets<br /> opportunity.</h1>
        <p className="mt-8 text-lg text-[#CDC7BA] leading-relaxed">
          SV Talent Agency is a talent discovery, casting and representation platform. We connect
          exceptional models, actors, creators and performers with meaningful opportunities across
          fashion, music, film, advertising and digital media.
        </p>
      </section>

      <section className="max-w-[1000px] mx-auto px-4 py-12 grid md:grid-cols-3 gap-6">
        {[
          { l: "Talent Discovery" },
          { l: "Professional Casting" },
          { l: "Talent Representation" },
          { l: "Music Video Casting" },
          { l: "Film & Digital Casting" },
          { l: "Brand & Commercial Talent" },
        ].map((x) => (
          <div key={x.l} className="sv-card p-6 text-center">
            <div className="font-mono-label text-[10px] text-[#C5A059]">Focus</div>
            <div className="mt-2 font-display-cinzel text-sm text-[#F4EFE4]">{x.l}</div>
          </div>
        ))}
      </section>

      <section className="max-w-3xl mx-auto text-center px-4 py-16 border-t border-[rgba(255,255,255,0.06)]">
        <div className="sv-overline mb-4">Founder</div>
        <h2 className="font-serif-hero text-3xl lg:text-5xl text-[#F4EFE4]">Senty Virk</h2>
        <div className="mt-2 font-mono-label text-[11px] text-[#C5A059]">Casting Director</div>
        <p className="mt-6 text-[#CDC7BA] leading-relaxed max-w-2xl mx-auto">
          Casting director behind a curated selection of music-video productions across Punjabi
          and Indian music, with a professional focus on model management, fashion and commercial
          casting.
        </p>
      </section>

      <section className="max-w-3xl mx-auto text-center px-4 py-16">
        <div className="flex justify-center gap-4">
          <Link to="/contact" className="sv-btn-primary">Work With SV Talent</Link>
          <Link to="/join" className="sv-btn-outline">Join SV Talent</Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
